
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import { capitalize } from 'lodash';
import MealChip from '@/components/menu/rotational-menus/MealChip.vue';

@Component<MealSelectionPanel>({
	components: {
		MealChip
	}
})
export default class MealSelectionPanel extends Vue {
	@Prop({ type: String, required: true }) private date!: string;
	@Prop({ type: Object, required: false, default: null }) private rotationalMenu!: RotationalMenu | null;
	@Prop({ type: Array, required: false, default: () => [] }) private selectedItemIds!: number[];

	private get weekday(): string {
		return capitalize(DateTime.fromISO(this.date).setLocale(this.$i18n.locale).toFormat('EEEE'));
	}

	private get fullDate(): string {
		return capitalize(DateTime.fromISO(this.date).setLocale(this.$i18n.locale).toFormat('DD'));
	}

	/**
	 * Build the menu groups for the day with their full item lists (no cap).
	 *
	 * @return {MealGroup[]}
	 */
	private get mealGroups(): MealGroup[] {
		if (!this.rotationalMenu) {
			return [];
		}
		return this.rotationalMenu.menus.map((menu: Menu) => ({
			id: menu.id,
			name: this.$options.filters!.localize(menu, 'name'),
			items: [...menu.items, ...menu.sections.flatMap((section: MenuSection) => section.items)]
		})).filter((group: MealGroup) => group.items.length);
	}

	private isSelected(item: MenuItem): boolean {
		return this.selectedItemIds.includes(item.id);
	}
}
